// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 2H6.75C7.43 2 7.96 2.23 8.44 2.71L13.49 7.76C14.27 8.54 14.27 9.8 13.49 10.58L10.58 13.49C9.8 14.27 8.54 14.27 7.76 13.49L2.71 8.44C2.23 7.96 2 7.43 2 6.75V4C2 2.9 2.9 2 4 2Z',
  'M5.05 5.05H5.06',
];
